import React from 'react'
import Firebase from 'firebase';
import Select from 'react-select';
import PricingTables from '../dashBoard/pricingTables'



const options = [
    {
        label: "Amazon S3",
        value: "S3"
    },
    {
        label: "Servidor FTP",
        value: "FTP"
    }
];

export default class autoUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: "nuevo"
        }
        this.renderFTP = this.renderFTP.bind(this);
        this.renderS3 = this.renderS3.bind(this);
    }

    renderS3() {
        return (
            <div className="card card-outline-primary mb-3" style={{ padding: "10px", borderRadius: "20px" }}>
                <div style={{ position: "absolute", left: "0", right: "0", top: "30%", zIndex: "10" }}>
                    <PricingTables />
                </div>
                <div className="card-block">
                    <blockquote className="card-blockquote">
                        <legend>Amazon S3:</legend>
                        <hr />
                        <div className="form-group">
                            <label>Credenciales :</label>
                            <div className="input-group">
                                <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Access_Key:</span>
                                <input type="text" className="form-control" id="company" value={this.state.access_key} />
                            </div>
                            <br />
                            <div className="input-group">
                                <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Secret_Key:</span>
                                <input type="text" className="form-control" id="company" value={this.state.secret_key} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Directorio raiz :</label>
                            <div className="input-group">
                                <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Bucket:</span>
                                <input type="text" className="form-control" id="company" value={this.state.bucket} />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Directorio de archivos :</label>
                            <div className="input-group">
                                <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Path:</span>
                                <input type="text" className="form-control" id="company" value={this.state.path} />
                            </div>
                        </div>
                    </blockquote>
                </div>
            </div>
        )
    }

    renderFTP() {
        return (
            <div className="card card-outline-primary mb-3" style={{ padding: "10px", borderRadius: "20px" }}>
                <div className="card-block">
                    <blockquote className="card-blockquote">
                        <legend>Servidor FTP:</legend>
                        <hr />
                        <div className="form-group">
                            <label>Credenciales :</label>
                            <div className="input-group">
                                <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Dirección FTP:</span>
                                <input type="text" className="form-control" id="company" value={this.state.FTP} />
                            </div>
                            <br />
                            <div className="input-group">
                                <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Usuario:</span>
                                <input type="text" className="form-control" id="company" value={this.state.FTP_user} />
                            </div>
                            <br />
                            <div className="input-group">
                                <span className="input-group-addon" style={{ width: "100px", backgroundColor: "#CCCCCC" }}>Contraseña:</span>
                                <input type="password" className="form-control" id="company" value={this.state.FTP_pass} />
                            </div>
                        </div>
                    </blockquote>
                </div>
            </div>
        )
    }

    render() {
        if (this.state.fuentes_externas) {
            return (
                <div style={{ padding: "20px" }}>
                    <h3>Configurar conexión con fuentes externas</h3>
                    <p>Debe completar los datos a continuación para realizar el envio automático de los datos.</p>
                    <br />
                    <div className="form-group">
                        <label>Seleccione una opción</label>
                        <Select
                            name="form-field-name"
                            className="Select Select--single is-clearable is-searchable has-value"
                            value={this.state.option}
                            options={options}
                            onChange={(e) => {
                                this.setState({ option: e.value });
                            }}
                        />
                    </div>
                    <div className="form-group">
                        {
                            this.state.option === "FTP" ?
                                this.renderFTP()
                                :
                                this.renderS3()
                        }
                    </div>
                    <div className="form-group">
                        <label htmlFor="name">Periodicidad: </label>
                        <input type="text" className="form-control" id="name" value={this.state.periodicidad} onChange={(e) => { this.setState({ periodicidad: e.target.value }) }}
                            placeholder="Periodo de tiempo para la actualización automática" />
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="callout callout-warning" style={{padding : "10px"}}>
                    <h1>Acceso restringido</h1>
                    <h6>Para poder obtener esta y otras funcionalidades debe actualizar su plan</h6>
                    <a type="button" href="https://www.operatio.cl/planes" target="_blank" className="btn btn-info">Ver planes</a>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/datasets/autoUpdate.js